(() => {
  const header = document.querySelector('[data-site-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  let drawer = document.querySelector('[data-cart-drawer]');
  let returnFocus = null;

  const syncHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 20);
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  const pinnedHero = document.querySelector('[data-pinned-hero]');
  const parallaxItems = pinnedHero?.querySelectorAll('[data-hero-parallax]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const featureCarousels = new Map();
  const initializeFeatureCarousels = (scope = document) => {
    const carousels = [];
    if (scope.matches?.('[data-feature-carousel]')) carousels.push(scope);
    scope.querySelectorAll?.('[data-feature-carousel]').forEach((carousel) => carousels.push(carousel));

    carousels.forEach((carousel) => {
      if (featureCarousels.has(carousel)) return;
      const track = carousel.querySelector('[data-feature-track]');
      const slides = [...carousel.querySelectorAll('[data-feature-slide]')];
      const controls = carousel.querySelector('[data-feature-controls]');
      const previous = carousel.querySelector('[data-feature-previous]');
      const next = carousel.querySelector('[data-feature-next]');
      const toggle = carousel.querySelector('[data-feature-toggle]');
      const pagination = [...carousel.querySelectorAll('[data-feature-select]')];
      if (!track || slides.length < 2 || !controls || !previous || !next || !toggle) return;

      let activeIndex = slides.length > 2 ? 1 : 0;
      let lastDirection = 0;
      let visible = false;
      let hovered = false;
      let focused = false;
      let userPaused = false;
      let timer = null;
      let swipeStartX = null;
      let swipePointerId = null;
      const removers = [];
      const listen = (target, type, handler, options) => {
        target.addEventListener(type, handler, options);
        removers.push(() => target.removeEventListener(type, handler, options));
      };
      const updateToggle = () => {
        const label = userPaused ? carousel.dataset.resumeLabel : carousel.dataset.pauseLabel;
        const text = userPaused ? carousel.dataset.resumeText : carousel.dataset.pauseText;
        toggle.textContent = text || label || '';
        toggle.setAttribute('aria-label', label || text || '');
      };
      const render = () => {
        const stageWidth = track.getBoundingClientRect().width;
        const cardWidth = slides[activeIndex].offsetWidth;
        const sideOffset = window.matchMedia('(max-width: 800px)').matches ? cardWidth * 0.95 + 12 : cardWidth + 28;
        slides.forEach((slide, index) => {
          let offset = index - activeIndex;
          if (slides.length === 3 && offset > 1) offset -= slides.length;
          if (slides.length === 3 && offset < -1) offset += slides.length;
          if (slides.length === 2 && offset !== 0) offset = lastDirection > 0 ? -1 : 1;
          const selected = index === activeIndex;
          slide.style.setProperty('--carousel-x', `${offset * sideOffset}px`);
          slide.style.setProperty('--carousel-scale', selected ? '1' : '.94');
          slide.setAttribute('aria-hidden', String(!selected));
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', carousel.dataset.slideLabel || 'slide');
          slide.setAttribute('aria-label', slide.dataset.slidePosition || `${index + 1} of ${slides.length}`);
          slide.inert = !selected;
        });
        pagination.forEach((button, index) => button.setAttribute('aria-current', String(index === activeIndex)));
      };
      const advance = (direction) => {
        lastDirection = direction;
        activeIndex = (activeIndex + direction + slides.length) % slides.length;
        render();
      };
      const syncTimer = () => {
        const shouldAdvance = visible && !hovered && !focused && !userPaused && !document.hidden && !reducedMotion.matches;
        if (shouldAdvance && timer === null) timer = window.setInterval(() => advance(1), 6500);
        if (!shouldAdvance && timer !== null) {
          window.clearInterval(timer);
          timer = null;
        }
      };
      const pauseForInteraction = () => {
        userPaused = true;
        updateToggle();
        syncTimer();
      };

      carousel.classList.add('is-enhanced');
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-roledescription', carousel.dataset.carouselLabel || 'carousel');
      controls.hidden = false;
      toggle.hidden = reducedMotion.matches;
      render();
      updateToggle();

      listen(previous, 'click', () => { pauseForInteraction(); advance(-1); });
      listen(next, 'click', () => { pauseForInteraction(); advance(1); });
      listen(toggle, 'click', () => {
        userPaused = !userPaused;
        updateToggle();
        syncTimer();
      });
      pagination.forEach((button) => listen(button, 'click', () => {
        pauseForInteraction();
        activeIndex = Number(button.dataset.featureSelect) || 0;
        render();
      }));
      listen(carousel, 'pointerenter', () => { hovered = true; syncTimer(); });
      listen(carousel, 'pointerleave', () => { hovered = false; syncTimer(); });
      listen(carousel, 'focusin', () => { focused = true; syncTimer(); });
      listen(carousel, 'focusout', (event) => {
        focused = carousel.contains(event.relatedTarget);
        syncTimer();
      });
      listen(carousel, 'keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); pauseForInteraction(); advance(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); pauseForInteraction(); advance(1); }
      });
      listen(track, 'pointerdown', (event) => {
        if (event.target.closest('button,a') || (event.button !== 0 && event.pointerType !== 'touch')) return;
        swipeStartX = event.clientX;
        swipePointerId = event.pointerId;
        if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
      });
      listen(track, 'pointerup', (event) => {
        if (swipeStartX === null || event.pointerId !== swipePointerId) return;
        const distance = event.clientX - swipeStartX;
        swipeStartX = null;
        swipePointerId = null;
        if (Math.abs(distance) < 45) return;
        pauseForInteraction();
        advance(distance < 0 ? 1 : -1);
      });
      const clearSwipe = () => { swipeStartX = null; swipePointerId = null; };
      listen(track, 'pointercancel', clearSwipe);
      listen(track, 'lostpointercapture', clearSwipe);
      listen(document, 'visibilitychange', syncTimer);
      const motionChange = () => {
        toggle.hidden = reducedMotion.matches;
        syncTimer();
      };
      if (reducedMotion.addEventListener) listen(reducedMotion, 'change', motionChange);
      else if (reducedMotion.addListener) {
        reducedMotion.addListener(motionChange);
        removers.push(() => reducedMotion.removeListener(motionChange));
      }

      let resizeObserver = null;
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(render);
        resizeObserver.observe(track);
      } else {
        listen(window, 'resize', render, { passive: true });
      }
      let visibilityObserver = null;
      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0);
          syncTimer();
        }, { threshold: 0.01 });
        visibilityObserver.observe(carousel);
      }

      featureCarousels.set(carousel, () => {
        if (timer !== null) window.clearInterval(timer);
        visibilityObserver?.disconnect();
        resizeObserver?.disconnect();
        removers.forEach((remove) => remove());
        featureCarousels.delete(carousel);
      });
    });
  };
  const unloadFeatureCarousels = (scope) => {
    [...featureCarousels.entries()].forEach(([carousel, dispose]) => {
      if (scope === carousel || scope.contains?.(carousel)) dispose();
    });
  };
  initializeFeatureCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeFeatureCarousels(event.target));
  document.addEventListener('shopify:section:unload', (event) => unloadFeatureCarousels(event.target));

  if (pinnedHero && parallaxItems?.length && !reducedMotion.matches && window.matchMedia('(min-width: 801px)').matches) {
    let ticking = false;
    const updateParallax = () => {
      const bounds = pinnedHero.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -bounds.top / Math.max(1, bounds.height)));
      parallaxItems.forEach((item) => {
        const direction = item.dataset.heroParallax === 'left' ? -1 : 1;
        item.style.setProperty('--parallax-y', `${progress * direction * 82}px`);
      });
      ticking = false;
    };
    const requestParallax = () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateParallax); }
    };
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax, { passive: true });
    requestParallax();
  }

  document.querySelectorAll('[data-hero-loop-video]').forEach((heroSideVideo) => {
    const heroSideSlot = heroSideVideo.closest('[data-hero-loop-slot]');
    if (!heroSideSlot || !('IntersectionObserver' in window)) return;
    const desktopHero = window.matchMedia('(min-width: 801px) and (min-height: 601px), (min-width: 1025px)');
    const allViewports = heroSideSlot.hasAttribute('data-loop-all-viewports');
    const heroSideToggle = heroSideSlot.querySelector('[data-hero-loop-toggle]');
    const heroSideToggleLabel = heroSideToggle?.querySelector('[data-hero-side-toggle-label]');
    let heroSideInView = false;
    let heroSideUserPaused = false;
    const updateHeroSideToggle = () => {
      if (!heroSideToggle) return;
      const paused = heroSideVideo.paused;
      heroSideToggle.setAttribute('aria-label', paused ? 'Play product video' : 'Pause product video');
      if (heroSideToggleLabel) heroSideToggleLabel.textContent = paused ? 'Play' : 'Pause';
    };
    const syncHeroSidePlayback = () => {
      const motionAllowed = !reducedMotion.matches && (allViewports || desktopHero.matches);
      if (allViewports) heroSideVideo.hidden = !motionAllowed;
      if (!heroSideInView || document.hidden || !motionAllowed || heroSideUserPaused) {
        heroSideVideo.pause();
        if (!motionAllowed && allViewports) heroSideSlot.classList.remove('has-frame');
      } else {
        const playRequest = heroSideVideo.play();
        playRequest?.catch(() => heroSideSlot.classList.remove('has-frame'));
      }
      if (heroSideToggle) {
        heroSideToggle.hidden = !heroSideInView || document.hidden || !motionAllowed;
        updateHeroSideToggle();
      }
    };
    heroSideToggle?.addEventListener('click', () => {
      heroSideUserPaused = !heroSideVideo.paused;
      syncHeroSidePlayback();
    });
    heroSideVideo.addEventListener('playing', () => {
      heroSideSlot.classList.add('has-frame');
      updateHeroSideToggle();
    });
    heroSideVideo.addEventListener('pause', updateHeroSideToggle);
    heroSideVideo.addEventListener('error', () => heroSideSlot.classList.remove('has-frame'));
    const heroSideObserver = new IntersectionObserver((entries) => {
      heroSideInView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0);
      syncHeroSidePlayback();
    }, { threshold: 0.01 });
    heroSideObserver.observe(heroSideVideo);
    document.addEventListener('visibilitychange', syncHeroSidePlayback);
    window.addEventListener('resize', syncHeroSidePlayback, { passive: true });
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', syncHeroSidePlayback);
    else reducedMotion.addListener(syncHeroSidePlayback);
    if (desktopHero.addEventListener) desktopHero.addEventListener('change', syncHeroSidePlayback);
    else desktopHero.addListener(syncHeroSidePlayback);
  });

  const productOverType = document.querySelector('[data-product-over-type]');
  if (productOverType) {
    const desktopProductStory = window.matchMedia('(min-width: 801px) and (min-height: 601px)');
    let ticking = false;
    const updateProductStory = () => {
      if (reducedMotion.matches || !desktopProductStory.matches) {
        productOverType.classList.remove('has-scroll-motion');
        productOverType.style.removeProperty('--heading-offset');
        productOverType.style.removeProperty('--product-image-top');
        productOverType.style.removeProperty('--bottom-opacity');
        productOverType.style.removeProperty('--bottom-pointer-events');
        ticking = false;
        return;
      }

      productOverType.classList.add('has-scroll-motion');
      const sectionTop = productOverType.getBoundingClientRect().top;
      const scale = window.innerHeight / 900;
      const measuredSectionTop = sectionTop / scale;
      const headingOffset = Math.max(0, Math.min(385, measuredSectionTop + 135)) * scale;
      let imageTop;
      if (measuredSectionTop >= 250) {
        imageTop = 741;
      } else if (measuredSectionTop >= 25) {
        imageTop = 328 + (measuredSectionTop - 25) * (663 / 225) - measuredSectionTop;
      } else if (measuredSectionTop >= 0) {
        imageTop = 188 + (measuredSectionTop + 200) * (140 / 225) - measuredSectionTop;
      } else if (measuredSectionTop >= -200) {
        imageTop = 188 + (measuredSectionTop + 200) * (140 / 225);
      } else {
        imageTop = 188;
      }

      const bottomOpacity = measuredSectionTop <= -200 ? 1 : 0;
      productOverType.style.setProperty('--heading-offset', `${headingOffset}px`);
      productOverType.style.setProperty('--product-image-top', `${imageTop * scale}px`);
      productOverType.style.setProperty('--bottom-opacity', `${bottomOpacity}`);
      productOverType.style.setProperty('--bottom-pointer-events', bottomOpacity === 1 ? 'auto' : 'none');
      ticking = false;
    };
    const requestProductStoryUpdate = () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateProductStory); }
    };
    window.addEventListener('scroll', requestProductStoryUpdate, { passive: true });
    window.addEventListener('resize', requestProductStoryUpdate, { passive: true });
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', requestProductStoryUpdate);
    else reducedMotion.addListener(requestProductStoryUpdate);
    if (desktopProductStory.addEventListener) desktopProductStory.addEventListener('change', requestProductStoryUpdate);
    else desktopProductStory.addListener(requestProductStoryUpdate);
    requestProductStoryUpdate();
  }

  const closeMenu = () => {
    if (!menuToggle || !mobileMenu) return;
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', 'Open menu');
    mobileMenu.classList.remove('is-open');
  };

  menuToggle?.addEventListener('click', () => {
    const open = menuToggle.getAttribute('aria-expanded') !== 'true';
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    mobileMenu?.classList.toggle('is-open', open);
  });
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

  const openDrawer = (trigger) => {
    if (!drawer) return;
    returnFocus = trigger || document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]:not(.drawer-scrim)')?.focus();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.removeAttribute('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    returnFocus?.focus?.();
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', () => openDrawer(button)));
  drawer?.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      closeMenu();
    }
    if (event.key === 'Tab' && drawer?.hasAttribute('open')) {
      const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  document.querySelectorAll('[data-quantity-step]').forEach((button) => button.addEventListener('click', () => {
    const input = button.closest('.quantity-wrap')?.querySelector('input');
    if (!input) return;
    const min = Number(input.min || 1);
    const max = Number(input.max || Number.MAX_SAFE_INTEGER);
    input.value = String(Math.max(min, Math.min(max, Number(input.value || min) + Number(button.dataset.quantityStep))));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  const variantSelect = document.querySelector('[data-variant-select]');
  const variantInput = document.querySelector('input[name="id"][type="hidden"]');
  const qtyInput = document.querySelector('[data-product-quantity]');
  const productRoot = document.querySelector('[data-product-root]');
  const addButton = document.querySelector('[data-add-button]');
  const finalAddButton = document.querySelector('[data-final-add]');
  const buyNowButton = document.querySelector('[data-buy-now]');
  const availability = document.querySelector('[data-availability]');
  const pricePresentation = window.FullyKitted?.pricePresentation;
  const flow = window.FullyKitted?.flow;
  const welcomeOffer = document.querySelector('[data-welcome-offer]');
  const welcomeAfter = welcomeOffer?.querySelector('[data-welcome-after]');
  const welcomeQuantity = welcomeOffer?.querySelector('[data-welcome-quantity]');
  const welcomeTotalLabel = welcomeOffer?.querySelector('[data-welcome-total-label]');
  const baseTotalLabel = welcomeOffer?.querySelector('[data-base-total-label]');
  const basePriceRow = welcomeOffer?.querySelector('[data-base-price-row]');
  const deliveryEstimate = welcomeOffer?.querySelector('[data-delivery-estimate]');
  const welcomeTerms = welcomeOffer?.querySelector('[data-welcome-terms]');
  const estimateBox = document.querySelector('[data-estimate]');
  const purchaseBar = document.querySelector('[data-purchase-bar]');
  const barAdd = document.querySelector('[data-bar-add]');
  const barTotal = document.querySelector('[data-purchase-bar-total]');
  const barContext = document.querySelector('[data-purchase-bar-context]');
  const barBaseContext = document.querySelector('[data-purchase-bar-base-context]');
  const finalEstimate = document.querySelector('[data-final-estimate]');
  const finalEstimateLabel = document.querySelector('[data-final-estimate-label]');
  const finalBaseLabel = document.querySelector('[data-final-base-label]');
  const finalContext = document.querySelector('[data-final-context]');
  const finalBase = document.querySelector('[data-final-base]');
  const finalBaseRow = document.querySelector('[data-final-base-row]');
  const basePrice = welcomeOffer?.querySelector('[data-base-price]');
  const buyArea = document.querySelector('[data-buy-area]');
  const selectedOption = () => variantSelect?.selectedOptions[0] || variantInput || null;
  const query = new URLSearchParams(window.location.search);
  const requestedVariant = query.get('variant');
  const requestedQuantity = Number(query.get('quantity'));
  let discountHandoff = null;
  try { discountHandoff = productRoot ? (flow?.consumeDiscountHandoff(window.sessionStorage, window.location.pathname) || null) : null; } catch (e) { discountHandoff = null; }
  const preferredVariantId = requestedVariant || discountHandoff?.variantId;
  let restoredVariantId = null;
  if (variantSelect && preferredVariantId) {
    const option = [...variantSelect.options].find((candidate) => candidate.value === preferredVariantId
      && candidate.dataset.available === 'true' && !candidate.disabled);
    if (option) { variantSelect.value = option.value; restoredVariantId = option.value; }
  } else if (variantInput && preferredVariantId === variantInput.value && variantInput.dataset.available === 'true') {
    restoredVariantId = variantInput.value;
  }
  const activeVariantId = restoredVariantId || selectedOption()?.value;
  const handoffQuantity = discountHandoff && activeVariantId != null && discountHandoff.variantId === activeVariantId
    ? discountHandoff.quantity
    : NaN;
  const initialQuantity = Number.isSafeInteger(requestedQuantity) && requestedQuantity >= 1 ? requestedQuantity : handoffQuantity;
  if (qtyInput && Number.isSafeInteger(initialQuantity) && initialQuantity >= 1) {
    const variantMax = Number(selectedOption()?.dataset.max || qtyInput.max) || Number.MAX_SAFE_INTEGER;
    qtyInput.value = String(Math.min(initialQuantity, variantMax));
  }
  let lastValidQuantity = Number(qtyInput?.value) >= 1 ? Number(qtyInput.value) : 1;
  const currentQuantity = () => flow?.clampQuantity(qtyInput?.value ?? lastValidQuantity, lastValidQuantity, qtyInput?.max)?.quantity ?? lastValidQuantity;
  const currencyIso = estimateBox?.dataset.currency || 'ZAR';
  const formatPrice = (cents) => {
    if (currencyIso === 'ZAR' && pricePresentation?.formatZar) return pricePresentation.formatZar(cents) || '';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currencyIso }).format(Number(cents) / 100); }
    catch { return ''; }
  };
  const refreshWelcomeOffer = () => {
    if (!productRoot || !welcomeOffer || !welcomeAfter || !estimateBox) return;
    const option = selectedOption();
    const unit = Number(option?.dataset.priceCents ?? estimateBox.dataset.unitCents);
    const physical = (option?.dataset.physical ?? estimateBox.dataset.physical) !== 'false';
    const count = currentQuantity();
    const estimate = physical ? flow?.estimateFor(unit, count, currencyIso) : null;
    const discountTotal = pricePresentation?.discountedTotal(unit, count, 15);
    const hasWelcomeEstimate = currencyIso === 'ZAR' && physical && Boolean(estimate) && Number.isFinite(discountTotal);
    // Unsupported currencies and non-physical variants must fall back to the
    // product subtotal. Do not carry any shipping estimate into that label.
    const baseTotal = unit * count;
    const discounted = hasWelcomeEstimate ? discountTotal + estimate.shippingCents : baseTotal;
    const visibleTotal = formatPrice(discounted);
    welcomeAfter.textContent = visibleTotal;
    if (welcomeTotalLabel) welcomeTotalLabel.hidden = !hasWelcomeEstimate;
    if (baseTotalLabel) baseTotalLabel.hidden = hasWelcomeEstimate;
    if (welcomeQuantity) {
      welcomeQuantity.hidden = !hasWelcomeEstimate;
      welcomeQuantity.textContent = `${welcomeQuantity.dataset.welcomeLabel || 'With WELCOME15 · if eligible'} · ${count} ${count === 1 ? 'kit' : 'kits'}`;
    }
    if (basePriceRow) basePriceRow.hidden = !hasWelcomeEstimate;
    if (deliveryEstimate) deliveryEstimate.hidden = !hasWelcomeEstimate;
    if (welcomeTerms) welcomeTerms.hidden = !hasWelcomeEstimate;
    if (basePrice) basePrice.textContent = option?.dataset.price || basePrice.textContent;
    if (barTotal) barTotal.textContent = visibleTotal;
    if (barContext) barContext.hidden = !hasWelcomeEstimate;
    if (barBaseContext) barBaseContext.hidden = hasWelcomeEstimate;
    if (finalEstimate) finalEstimate.textContent = visibleTotal;
    if (finalEstimateLabel) finalEstimateLabel.hidden = !hasWelcomeEstimate;
    if (finalBaseLabel) finalBaseLabel.hidden = hasWelcomeEstimate;
    if (finalContext) {
      finalContext.hidden = !hasWelcomeEstimate;
      finalContext.textContent = `${finalContext.dataset.finalLabel || 'With WELCOME15 · if eligible'} · ${count} ${count === 1 ? 'kit' : 'kits'}`;
    }
    if (finalBaseRow) finalBaseRow.hidden = !hasWelcomeEstimate;
    if (finalBase) finalBase.textContent = option?.dataset.price || finalBase.textContent;
  };
  const refreshPricePairs = (option) => {
    const available = (option?.dataset?.available ?? 'true') === 'true';
    if (barAdd) barAdd.disabled = !available;
  };
  const overlayOpen = () => Boolean(document.querySelector('[data-cart-drawer][open]'))
    || Boolean(document.querySelector('dialog[open]'));
  const syncPurchaseBar = () => {
    if (!purchaseBar || !buyArea) return;
    const past = buyArea.getBoundingClientRect().bottom < 0;
    const mobile = window.matchMedia('(max-width: 800px)').matches;
    const shouldHide = !(mobile && past && !overlayOpen());
    if (purchaseBar.hidden !== shouldHide) purchaseBar.hidden = shouldHide;
  };
  if (buyArea && purchaseBar) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(syncPurchaseBar, { threshold: 0 }).observe(buyArea);
    }
    window.addEventListener('scroll', syncPurchaseBar, { passive: true });
    window.addEventListener('resize', syncPurchaseBar, { passive: true });
    new MutationObserver(syncPurchaseBar).observe(document.body, { attributes: true, attributeFilter: ['open', 'hidden'], subtree: true });
  }
  const updateVariant = (resetQuantity = false) => {
    const option = selectedOption();
    if (!option) { refreshPricePairs(selectedOption()); refreshWelcomeOffer(); return; }
    if (availability) {
      const available = option.dataset.available === 'true';
      availability.textContent = available ? window.FullyKitted.strings.available : window.FullyKitted.strings.unavailable;
      availability.classList.toggle('product-availability--out', !available);
    }
    if (addButton) {
      const available = option.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? window.FullyKitted.strings.addToCart : window.FullyKitted.strings.soldOut;
    }
    if (buyNowButton) buyNowButton.disabled = option.dataset.available !== 'true';
    if (finalAddButton) finalAddButton.disabled = option.dataset.available !== 'true';
    if (qtyInput) {
      if (option.dataset.max) qtyInput.max = option.dataset.max;
      else qtyInput.removeAttribute('max');
      if (resetQuantity) qtyInput.value = '1';
      const max = Number(qtyInput.max) || Number.MAX_SAFE_INTEGER;
      const count = Math.max(1, Math.min(max, Math.floor(Number(qtyInput.value) || 1)));
      qtyInput.value = String(count);
      lastValidQuantity = count;
    }
    refreshPricePairs(option);
    refreshWelcomeOffer();
    syncPurchaseBar();
  };
  variantSelect?.addEventListener('change', () => updateVariant(true));
  qtyInput?.addEventListener('input', refreshWelcomeOffer);
  qtyInput?.addEventListener('change', () => {
    if (!flow || !qtyInput) return;
    const current = flow.clampQuantity(qtyInput.value, qtyInput.value, qtyInput.max);
    if (!current.valid) qtyInput.value = String(flow.clampQuantity(qtyInput.value, lastValidQuantity, qtyInput.max).quantity);
    else lastValidQuantity = current.quantity;
    refreshWelcomeOffer();
  });
  if (productRoot) updateVariant();

  const galleryButtons = [...document.querySelectorAll('[data-gallery-thumb]')];
  galleryButtons.forEach((thumb) => thumb.addEventListener('click', () => {
    if (window.matchMedia('(max-width: 800px)').matches) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
    thumb.setAttribute('aria-current', 'true');
  }));
  const mobileGalleryButtons = [...document.querySelectorAll('[data-gallery-mobile-thumb]')];
  mobileGalleryButtons.forEach((thumb, index) => thumb.addEventListener('click', () => {
    const main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    const selectedImage = thumb.dataset.image;
    const selectedAlt = thumb.dataset.alt || '';
    main.src = selectedImage;
    main.alt = selectedAlt;
    main.dataset.selectedImage = selectedImage;
    main.dataset.selectedAlt = selectedAlt;
    mobileGalleryButtons.forEach((item) => item.setAttribute('aria-current', 'false'));
    thumb.setAttribute('aria-current', 'true');
    galleryButtons.forEach((item) => item.setAttribute('aria-current', 'false'));
    galleryButtons[index]?.setAttribute('aria-current', 'true');
  }));
  const dialog = document.querySelector('[data-image-dialog]');
  const dialogImage = dialog?.querySelector('[data-dialog-image]');
  let galleryReturnFocus = null;
  const restoreGalleryFocus = () => {
    const target = flow?.restoreTarget({
      connected: Boolean(galleryReturnFocus?.isConnected),
      isBody: galleryReturnFocus === document.body || galleryReturnFocus === document.documentElement,
      insideDialog: Boolean(dialog?.contains(galleryReturnFocus)),
    });
    if (target === 'origin' && galleryReturnFocus?.focus) galleryReturnFocus.focus({ preventScroll: true });
    else document.querySelector('#MainContent')?.focus({ preventScroll: true });
  };
  document.querySelectorAll('[data-gallery-open]').forEach((button) => button.addEventListener('click', () => {
    if (!dialog || !dialogImage) return;
    const isMobile = window.matchMedia('(max-width: 800px)').matches;
    if (isMobile && button !== galleryButtons[0]) return;
    const mainImage = button.querySelector('[data-gallery-main]');
    dialogImage.src = mainImage?.dataset.selectedImage || button.dataset.image || mainImage?.src || button.querySelector('img')?.src || '';
    dialogImage.alt = mainImage?.dataset.selectedAlt || button.dataset.alt || mainImage?.alt || button.querySelector('img')?.alt || '';
    galleryReturnFocus = document.activeElement;
    dialog.showModal();
  }));
  document.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('close', restoreGalleryFocus);

  const updateCartCount = async () => {
    const response = await fetch(`${window.FullyKitted.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart refresh failed');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count ? String(cart.item_count) : ''; });
  };

  const refreshDrawer = async () => {
    const url = `${window.FullyKitted.routes.cart}?section_id=cart-drawer`;
    const response = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('cart drawer refresh failed');
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('#shopify-section-cart-drawer');
    const current = document.querySelector('#shopify-section-cart-drawer');
    if (fresh && current) {
      current.replaceWith(fresh);
      drawer = fresh.querySelector('[data-cart-drawer]');
      fresh.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    }
  };

  const submitGuard = window.FullyKitted?.flow?.createSubmitGuard();
  productRoot?.querySelector('form[action*="/cart/add"]')?.addEventListener('submit', async (event) => {
    const form = event.currentTarget;
    const returnTarget = form.querySelector('[data-return-target]');
    if (returnTarget) {
      if (!window.fetch || !window.FullyKitted) return;
      event.preventDefault();
      const submitter = event.submitter || form.querySelector('[data-add-button]');
      const message = form.querySelector('[data-form-message]');
      if (!submitter || submitter.disabled || (submitGuard && !submitGuard.tryAcquire())) return;
      const previousLabel = submitter.textContent;
      const destination = submitter.hasAttribute('data-buy-now')
        ? returnTarget.dataset.checkoutTarget
        : returnTarget.dataset.cartTarget;
      const target = new URL(destination || '/cart', window.location.origin);
      const redirectTo = `${target.pathname}${target.search}`;
      const discountUrl = `${returnTarget.dataset.discountPath}?redirect=${encodeURIComponent(redirectTo)}`;
      submitter.disabled = true;
      submitter.textContent = 'Adding…';
      if (message) message.textContent = '';
      try {
        const response = await fetch(`${window.FullyKitted.routes.add}.js`, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || window.FullyKitted.strings.cartError);
        if (message) message.textContent = 'Applying WELCOME15 if eligible…';
        window.location.assign(discountUrl);
      } catch {
        if (message) message.textContent = 'With WELCOME15 · if eligible. Unable to add to cart. Please try again.';
        submitter.disabled = false;
        submitter.textContent = previousLabel;
        submitGuard?.release();
      }
      return;
    }
    if (!window.fetch || !window.FullyKitted) return;
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    const message = form.querySelector('[data-form-message]');
    if (!button || button.disabled) return;
    if (submitGuard && !submitGuard.tryAcquire()) return;
    button.disabled = true;
    const previous = button.textContent;
    button.textContent = 'Adding…';
    if (message) message.textContent = '';
    try {
      const response = await fetch(`${window.FullyKitted.routes.add}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || window.FullyKitted.strings.cartError);
      try {
        await Promise.all([updateCartCount(), refreshDrawer()]);
      } catch {
        submitGuard?.release();
        window.location.assign(window.FullyKitted.routes.cart);
        return;
      }
      button.textContent = window.FullyKitted.strings.added;
      openDrawer(button);
      window.setTimeout(() => { submitGuard?.release(); if (button.isConnected) { button.disabled = false; button.textContent = previous; } }, 1200);
    } catch (error) {
      submitGuard?.release();
      button.disabled = false;
      button.textContent = previous;
      if (message) message.textContent = error.message || window.FullyKitted.strings.cartError;
    }
  });

  // Homepage hero Buy now: add the selected available variant (quantity 1,
  // fixed in markup — no quantity control here) without touching existing
  // cart contents, then route through the discount link so WELCOME15 is
  // applied automatically when eligible. No-JS falls back to the native
  // form POST whose return_to already points at the discount link.
  document.querySelector('[data-hero-buy-form]')?.addEventListener('submit', async (event) => {
    const form = event.currentTarget;
    const returnTarget = form.querySelector('[data-hero-return]');
    if (!returnTarget || !window.fetch || !window.FullyKitted) return;
    event.preventDefault();
    const button = form.querySelector('[data-hero-buy-now]');
    const message = form.querySelector('[data-hero-message]');
    if (!button || button.disabled) return;
    if (submitGuard && !submitGuard.tryAcquire()) return;
    const previousLabel = button.textContent;
    const target = new URL(returnTarget.dataset.checkoutTarget || '/checkout', window.location.origin);
    const discountUrl = `${returnTarget.dataset.discountPath}?redirect=${encodeURIComponent(`${target.pathname}${target.search}`)}`;
    button.disabled = true;
    button.textContent = 'Adding…';
    if (message) message.textContent = '';
    try {
      const response = await fetch(`${window.FullyKitted.routes.add}.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || window.FullyKitted.strings.cartError);
      if (message) message.textContent = 'Applying WELCOME15 if eligible…';
      window.location.assign(discountUrl);
    } catch {
      if (message) message.textContent = 'With WELCOME15 · if eligible. Unable to add to cart. Please try again.';
      button.disabled = false;
      button.textContent = previousLabel;
      submitGuard?.release();
    }
  });

  // Cart page + cart drawer checkout: apply WELCOME15 automatically without
  // a manual code and without losing pending quantity edits. The discount
  // call never clears or replaces the cart; checkout always proceeds via
  // the shopper's own submit so no input is dropped. The checkout
  // submitter stays enabled so requestSubmit serializes name=checkout
  // (disabled controls are omitted from native form serialization).
  // A network/API failure retries once, then stops with a plain actionable
  // error instead of silently checking out without the code; genuine
  // ineligibility (update accepted, code not applied) stays Shopify-owned
  // and proceeds. Delegated (not per-node) so the handler survives
  // cart-drawer refreshes.
  const resetCartDiscountState = (cartForm) => {
    if (!cartForm) return;
    cartForm.dataset.fkCartDiscountPass = '';
    cartForm.dataset.fkCartBusy = '';
  };
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('form[action*="/cart"]:not([action*="/cart/add"])').forEach(resetCartDiscountState);
  });
  const applyCartDiscount = async () => {
    const send = () => fetch(`${window.FullyKitted.routes.cart}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: 'WELCOME15' }),
    });
    let failure = null;
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const response = await send();
        if (!response.ok) {
          failure = new Error(`discount update ${response.status}`);
          continue;
        }
        await response.json();
        return { ok: true };
      } catch (error) {
        failure = error;
      }
    }
    return { ok: false, error: failure };
  };
  document.addEventListener('submit', async (event) => {
    const cartForm = event.target?.closest?.('form[action*="/cart"]:not([action*="/cart/add"])');
    if (!cartForm || cartForm.dataset.fkCartDiscountPass === 'true') return;
    const submitter = event.submitter;
    const isCheckout = submitter?.name === 'checkout' || submitter?.hasAttribute('data-cart-checkout');
    if (!isCheckout || !window.fetch || !window.FullyKitted) return;
    if (cartForm.dataset.fkCartBusy === 'true') {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    cartForm.dataset.fkCartBusy = 'true';
    const message = cartForm.querySelector('[data-cart-discount-message]');
    if (message) message.textContent = '';
    const applied = await applyCartDiscount();
    cartForm.dataset.fkCartBusy = '';
    if (!applied.ok) {
      if (message) message.textContent = window.FullyKitted.strings.cartDiscountError || window.FullyKitted.strings.cartError;
      return;
    }
    cartForm.dataset.fkCartDiscountPass = 'true';
    try {
      if (typeof cartForm.requestSubmit === 'function') cartForm.requestSubmit(submitter);
      else {
        const fallback = document.createElement('input');
        fallback.type = 'hidden';
        fallback.name = 'checkout';
        fallback.value = 'true';
        cartForm.appendChild(fallback);
        cartForm.submit();
      }
    } catch {
      cartForm.dataset.fkCartDiscountPass = '';
    }
  });
})();



